import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function SolutionReveal() {
  const notThis = ['This is not a random collection of moves copied from the internet.', 'This is not a theory book you need to rewrite before it works in a real class.', 'This is not content designed for a different type of instructor that you would have to completely adapt.'];
  return <section className="border-y border-charcoal-line bg-charcoal-card px-4 py-20" data-id="element-215">
      <div className="mx-auto max-w-4xl text-center" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-217">
          <p className="mb-4 text-3xl text-gold-light" aria-hidden="true" data-id="element-218">
            ✦
          </p>
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-219">
            The most complete dance fitness teaching system for instructors
            worldwide
          </h2>
          <p className="mt-4 text-lg font-bold text-gold-light" data-id="element-220">
            Dance Fitness Instructor Pro™
          </p>
          <p className="mt-3 text-sm text-zinc-400" data-id="element-221">
            120 Ready-to-Teach Classes · 5 Strategic Bonuses · Everything Ready
            to Use From Today
          </p>
        </motion.div>
        <div className="mt-10 grid gap-5 text-left md:grid-cols-2" data-id="element-222">
          <div className="space-y-4 rounded-2xl border border-charcoal-line bg-charcoal p-6" data-id="element-223">
            {notThis.map(item => <p key={item} className="flex gap-3 text-sm leading-relaxed text-zinc-400" data-id="element-224">
                <XIcon size={18} className="shrink-0 text-zinc-500" data-id="element-225" />
                {item}
              </p>)}
          </div>
          <div className="rounded-2xl border border-gold/40 bg-gold/10 p-6" data-id="element-226">
            <p className="flex gap-3 text-base font-medium leading-relaxed text-white" data-id="element-227">
              <CheckIcon size={20} className="mt-0.5 shrink-0 text-gold-light" data-id="element-228" />
              This is a complete professional teaching system — so you walk into
              every single class fully prepared, fully confident, and ready to
              deliver a session your students will feel from the first beat to
              the final cooldown.
            </p>
          </div>
        </div>
      </div>
    </section>;
}